import { InternalAxiosRequestConfig } from "axios"

import { getToken } from "@/hooks/useAuthStorage"

function detectTenantSlug(): string | null {
  if (typeof window === "undefined") return null
  const host = window.location.hostname.toLowerCase()
  const firstPath = window.location.pathname.replace(/^\/+/, "").split("/")[0]?.toLowerCase() || ""

  if (host.includes("claricel") || firstPath === "claricel") return "claricel"
  if (host.includes("nxum") || firstPath === "nxum") return "nxum"
  if (host.includes("infynit") || firstPath === "infynit") return "infynit"
  if (host.includes("pandamovil") || firstPath === "pandamovil" || firstPath === "panda") return "pandamovil"
  if (host.includes("celink") || firstPath === "celink") return "celink"
  if (host.includes("figou") || firstPath === "figou") return "figou"
  if (host.includes("igou") || firstPath === "igou") return "igou"
  if (host.includes("beonline") || firstPath === "beonline") return "beonline"
  return null
}

function detectTenantCompanyId(): number | null {
  // No hardcodear IDs — cada instancia de API tiene sus propios IDs.
  // Solo usar VITE_ODOO_COMPANY_ID si está explícitamente configurado.
  const raw = String(import.meta.env.VITE_ODOO_COMPANY_ID ?? "").trim()
  if (!raw) return null
  const parsed = Number(raw)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}

export const validateAndApplyBearerToken = (
  config: InternalAxiosRequestConfig<any>
) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const tenantSlug = detectTenantSlug()
  const tenantCompanyId = detectTenantCompanyId()
  if (tenantSlug) {
    config.headers["X-Tenant-Slug"] = tenantSlug
  }
  if (tenantCompanyId != null) {
    config.headers["X-Company-Id"] = String(tenantCompanyId)
  }
}
